import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-664bd315"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup-main" }
const _hoisted_2 = { class: "content-header" }
const _hoisted_3 = { class: "main-header" }
const _hoisted_4 = {
  key: 0,
  class: "content-body popup-height"
}
const _hoisted_5 = {
  key: 1,
  class: "content-body popup-height"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Images", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Videos", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "3D Assets", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Audio", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_Search = _resolveComponent("Search")!
  const _component_UpdateCreateAssetForm = _resolveComponent("UpdateCreateAssetForm")!
  const _component_AssetItemComponent = _resolveComponent("AssetItemComponent")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_Scroller = _resolveComponent("Scroller")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.createAsset
          }, {
            default: _withCtx(() => [
              _createTextVNode("Create New Asset")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_Search, {
        items: _ctx.filteredAssets,
        onFiltered: _ctx.filtered,
        searchString: _ctx.filterString
      }, null, 8, ["items", "onFiltered", "searchString"])
    ]),
    _createVNode(_component_Scroller, null, {
      default: _withCtx(() => [
        (_ctx.showCreateForm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_UpdateCreateAssetForm, {
                campaignID: _ctx.campaignID,
                asset: _ctx.asset,
                method: _ctx.title,
                onSaved: _ctx.modifiedAsset
              }, null, 8, ["campaignID", "asset", "method", "onSaved"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_a_row, {
                gutter: 15,
                class: "stretch-height"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (_ctx.assets.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No assets have been created "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_ctx.filterCategory('Image').length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _hoisted_9,
                                  _hoisted_10,
                                  _hoisted_11,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCategory('Image'), (asset) => {
                                    return (_openBlock(), _createBlock(_component_AssetItemComponent, {
                                      key: `${asset.id}`,
                                      asset: asset,
                                      campaignID: _ctx.campaignID,
                                      onDelete: _ctx.modifiedAsset,
                                      onUpdate: _ctx.updateAsset,
                                      onUse: _cache[0] || (_cache[0] = ($event: any) => (_ctx.useAsset($event)))
                                    }, null, 8, ["asset", "campaignID", "onDelete", "onUpdate"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.filterCategory('Video').length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _hoisted_13,
                                  _hoisted_14,
                                  _hoisted_15,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCategory('Video'), (asset) => {
                                    return (_openBlock(), _createBlock(_component_AssetItemComponent, {
                                      key: `${asset.id}`,
                                      asset: asset,
                                      campaignID: _ctx.campaignID,
                                      onDelete: _ctx.modifiedAsset,
                                      onUpdate: _ctx.updateAsset,
                                      onUse: _cache[1] || (_cache[1] = ($event: any) => (_ctx.useAsset($event)))
                                    }, null, 8, ["asset", "campaignID", "onDelete", "onUpdate"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.filterCategory('3D Asset').length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _hoisted_17,
                                  _hoisted_18,
                                  _hoisted_19,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCategory('3D Asset'), (asset) => {
                                    return (_openBlock(), _createBlock(_component_AssetItemComponent, {
                                      key: `${asset.id}`,
                                      asset: asset,
                                      campaignID: _ctx.campaignID,
                                      onDelete: _ctx.modifiedAsset,
                                      onUpdate: _ctx.updateAsset,
                                      onUse: _cache[2] || (_cache[2] = ($event: any) => (_ctx.useAsset($event)))
                                    }, null, 8, ["asset", "campaignID", "onDelete", "onUpdate"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.filterCategory('Audio').length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _hoisted_21,
                                  _hoisted_22,
                                  _hoisted_23,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCategory('Audio'), (asset) => {
                                    return (_openBlock(), _createBlock(_component_AssetItemComponent, {
                                      key: `${asset.id}`,
                                      asset: asset,
                                      campaignID: _ctx.campaignID,
                                      onDelete: _ctx.modifiedAsset,
                                      onUpdate: _ctx.updateAsset,
                                      onUse: _cache[3] || (_cache[3] = ($event: any) => (_ctx.useAsset($event)))
                                    }, null, 8, ["asset", "campaignID", "onDelete", "onUpdate"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    })
  ]))
}